export const getCurrentRoute = (state) => state.location.type;
export const getPayload = (state) => state.location.payload;
export const getPathname = (state) => state.location.pathname;
